import { patientsRouteStore } from '../domain/store';
import { patientUpsertModalRouteStore } from '../domain/upsert-modal-store';

export default () => {
  patientUpsertModalRouteStore.setInitialState();
  patientsRouteStore.setValue('activePatientId', null);
  patientsRouteStore.setValue('showingPatientUpsertModal', false);
};
